<template>
  <div class="pl-4">

    <v-dialog v-model="showGraph" width="496">
      <component :is="graph" zoomed @close="showGraph=false" disableTo/>
    </v-dialog>

    <purtrak-table name="shopifylog" objectType="entries" :defaultColumns="defaultColumns" :headers="headers" ref="table"
                   api="shopify" hide-action
                   listEndPoint="shopifyLog" fields="date,number,created,customer,amount,error,method,info {salesOrderId,invoiceId,shipmentIds}"
                   :listFilters="listFilters" include-refresh
                   title="Shopify Log"
                   :print-info="{pageSize:'landscape', subTitle:[from?dateDisplay:'']}"
                   download-endpoint="shopifyLogExportCSV">
      <template v-slot:filter>
        <filter-menu include-reset @reset="status='2',from=null;to=nulll;search=''">
          <v-list-item>
            <filter-search :label="[{text:'Order #',value:'number'},{text:'Customer',value:'customer'},{text:'Error',value:'error'}]" v-model="search" :search-field.sync="searchField" :search-display.sync="searchDisplay"/>
          </v-list-item>
          <v-list-item>
            <date-range :from.sync="from" :to.sync="to" v-model="dateDisplay" option="All" allow-all/>
          </v-list-item>
          <v-list-item>
            <v-autocomplete label="Status" dense outlined :items="[{value:'2',text:'All'},{divider:true},{value:'1',text:'Success'},{value:'0',text:'Error'}]" v-model="status"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="search" close small class="ml-1" @click:close="search=''">{{searchDisplay}}</v-chip>
          <v-chip v-show="from!=null" close small class="ml-1" @click:close="from=null;to=null">{{dateDisplay}}</v-chip>
          <v-chip v-show="status!='2'" close small class="ml-1" @click:close="status='2'">{{status=='1'?'Success':'Error'}}</v-chip>
        </template>
      </template>
      <template v-slot:menu>
        <v-list-item @click="graphShow()"><v-list-item-title>Graph orders</v-list-item-title></v-list-item>
        <v-divider/>
        <v-list-item @click="showConfirm=true"><v-list-item-title>Clear log</v-list-item-title></v-list-item>
      </template>

      <template v-slot:item.date="{value}">
        {{value | formatDateTime}}
      </template>
      <template v-slot:item.method="{value}">
        {{value === 'RealTime' ? 'Real time' : value}}
      </template>
      <template v-slot:item.status="{item}">
        <v-menu v-if="item.error" open-on-hover offset-y>
          <template v-slot:activator="{ on }">
            <v-chip v-on="on" color="error" small @click="process(item)">Error</v-chip>
          </template>
          <v-card flat class="pa-4 text-center">
            <div class="error--text">{{item.error}}</div>
          </v-card>
        </v-menu>
        <v-menu v-else offset-y>
          <template v-slot:activator="{ on }">
            <v-chip v-on="on" color="success" small>Success</v-chip>
          </template>
          <v-list dense v-if="!!item.info.salesOrderId">
            <v-list-item :to="{name:'SalesSalesOrdersEdit',params:{salesOrderId:item.info.salesOrderId}}"><v-list-item-title>View Sales Order</v-list-item-title></v-list-item>
            <v-list-item v-if="!!item.info.invoiceId" :to="{name:'SalesInvoicesEdit',params:{invoiceId:item.info.invoiceId}}"><v-list-item-title>View Invoice</v-list-item-title></v-list-item>
            <template v-if="item.info.shipmentIds.length">
              <v-divider/>
              <template v-for="(shipmentId,index) in item.info.shipmentIds">
                <v-list-item :to="{name:'SalesShipmentsEdit',params:{shipmentId:shipmentId}}"><v-list-item-title>View Shipment {{item.info.shipmentIds.length > 1 ? index+1 : ''}}</v-list-item-title></v-list-item>
              </template>
            </template>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:item.created="{value}">
        {{value | formatDateTime}}
      </template>
      <template v-slot:item.amount="{value}">
        {{value | currency}}
      </template>
    </purtrak-table>

    <v-dialog v-model="showConfirm" persistent max-width="400">
      <v-card>
        <v-card-title>Clear log</v-card-title>
        <v-divider/>
        <v-card-text class="pt-4">
          Are you sure you want to <strong>permanently</strong> clear the log?
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer></v-spacer>
          <v-btn color="error" plain @click="clearLog()">Clear log</v-btn>
          <v-btn color="primary" @click="showConfirm=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import googleCharts from '@/mixins/googleCharts'

export default {
  name: 'AppsShopifyLog',
  mixins: [googleCharts],
  data() {
    return {
      graph: null,
      showGraph: false,
      search: '',
      searchField: 'number',
      searchDisplay: '',
      from: null,
      to: null,
      status: '2',
      dateDisplay: '',
      showConfirm: false,
      defaultColumns: [{ value: 'date', visible:true},
                       { value: 'status', visible:true},
                       { value: 'method', visible:true},
                       { value: 'number', visible:true},
                       { value: 'created', visible:true},
                       { value: 'customer', visible:true},
                       { value: 'amount', visible:true}],
      headers: [{text:'Date',value:'date',width:'15%',sortable:true},
                {text:'Status',value:'status',width:'10%',align:'center',sortable:false},
                {text:'Method',value:'method',width:'10%',sortable:true},
                {text:'Order #',value:'number',width:'10%',sortable:true},
                {text:'Order date',value:'created',width:'15%',sortable:true},
                {text:'Customer',value:'customer',width:'20%',sortable:true},
                {text:'Total',value:'amount',width:'10%',align:'right',sortable:true}]
    }
  },
  computed: {
    listFilters() {
      const filters = [];
      if (this.search)
        filters.push({field:this.searchField, comparator:'contains', value:this.search});
      if (this.from)
        filters.push({field:'date', comparator:'ge', value:`${this.from} 00:00:00`});
      if (this.to)
        filters.push({field:'date', comparator:'le', value:`${this.to} 23:59:59`});
      if (this.status !== '2')
        filters.push({field:'error', comparator:this.status == '1' ? 'isNull' : 'isNotNull', value:''});
      return filters;
    }
  },
  methods: {
    async graphShow() {
      await this.loadGoogleCharts();
      this.graph = () => import(`@/views/dashboard/DashboardShopify`);
      this.showGraph = true;
    },
    async clearLog() {
      const results = await this.$apiCall(`mutation AppsShopifyLog {shopifyClearLog}`, {}, false, 'shopify');
      if (!results.error) {
        this.$refs.table.buildList();
        this.showConfirm = false;
      }
    },
    async process(logItem) {
/*
      this.loading = true;
      const results = await this.$apiCall(`mutation AppsShopifyLog($number:String!) {
                                            shopifyProcessOrdersByNumber(number:$number, forceReprocessing:true) {total,errors}
                                          }`,
                                          {number:logItem.number}, false, 'shopify');
      this.loading = false;
      if (!results.error) {
        const orders = results.data.shopifyProcessOrdersByNumber;
        this.$store.commit('setError', {type:orders.errors?'warning':'success',
                                        message:`${orders.total} order(s) processed with ${orders.errors} error(s)${orders.errors?' (See Shopify log for details)':''}`});
      }
    */
    }
  }
}
</script>
